
import {computed, ComputedRef, defineComponent} from "vue";
import { removeQuery } from "../../utils/routing_utils";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {dispatchError} from "../../utils/error_handling";
import {isGTopTemplate} from "../mixins";

export default defineComponent({
  setup() {

    const router = useRouter();
    const store = useStore();
    const route = useRoute()

    const platformNames: ComputedRef<string> = computed(() => {
      if (isGTopTemplate()) {
        return "Escola GTOP"
      } else {
        return "Decola"
      }
    })

    const changeInputTerm = async (input: HTMLInputElement): Promise<void> => {

      try {
        if (input.checked) {
          await closeModal();
          await acceptTerm();
          /** Redirect them to the app's dashboard. */
          if (route.query.redirect) {
            await router.push(route.query.redirect as string);
          } else {
            await router.push({ name: "dashboard" });
          }
        }
      } catch (e) {
       await dispatchError(e);
      }
    }
    const closeModal = async (): Promise<void> => {
      await removeQuery(router, "acceptTerm")
    }

    const acceptTerm = async (): Promise<void> => {
      await store.dispatch("authentication_module/acceptTerm");
    };

    return {
      platformNames,
      closeModal,
      changeInputTerm,
    }
  }
});
